import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { BatchPaymentVM } from "@shared-kernel/application/ports/admin/admin-repository";
import {
  resetRetrieveProviderBatchParticipationPaymentList,
  retrieveProviderBatchParticipationPaymentList,
} from "@academy-context/read/application/use-cases/admin/provider-batch-participation-payment-list-retrieval/retrieve-provider-batch-participation-payment-list";

const initialState: RetrievalState<BatchPaymentVM[]> = { data: [], fetching: "idle" };

export const retrieveProviderBatchParticipationPaymentListReducer = createReducer<RetrievalState<BatchPaymentVM[]>>(
  initialState,
  builder => {
    builder.addCase(retrieveProviderBatchParticipationPaymentList.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(retrieveProviderBatchParticipationPaymentList.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(retrieveProviderBatchParticipationPaymentList.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
    builder.addCase(resetRetrieveProviderBatchParticipationPaymentList, () => {
      return initialState;
    });
  },
);
